import * as React from 'react';
import { inject, observer } from 'mobx-react';
import './coachingV2IntroductionPane.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import ImagePc from './images/coaching_renewal_popup-pc.png';
import ImageSp from './images/coaching_renewal_popup-sp.png';
import { routingStore } from '../../../../common/stores/routing';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import autobind from 'autobind-decorator';

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class CoachingV2IntroductionPane extends React.Component<Props> {
    submitState = new SubmitState();

    @autobind
    async closeCoachingV2Introduction() {
        const sp = GlobalStatesV3.viewport.isSp;
        await this.submitState.operate(async () => {
            await this.props.homeState.closeCoachingV2Introduction();
            if (sp) {
                routingStore.push(V3Routes.home());
            } else {
                routingStore.push(V3Routes.coachingSessions());
            }
        });
    }

    render() {
        const sp = GlobalStatesV3.viewport.isSp;
        return (
            <div id="coaching-v2-introduction-pane" styleName="pane">
                {sp ? <img src={ImageSp} styleName="introduction" /> : <img src={ImagePc} styleName="introduction" />}
                <div styleName="button-wrapper">
                    <Button
                        id="coaching-v2-introduction-pane-button"
                        type="primary"
                        size="l"
                        styleName="button"
                        loading={this.submitState.submitting}
                        onClick={this.closeCoachingV2Introduction}
                    >
                        確認しました（閉じる）
                    </Button>
                </div>
            </div>
        );
    }
}
